import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CourseType } from "../../../types/Course";
import { AcademicPeriodType } from "../../../types/AcademicPeriod";

const initialState: AcademicPeriodType = {
    id: "",
    idAcademicYear: "",
    startAdmissionExam: "",
    endAdmissionExam: "",
    startEnrollment: "",
    endEnrollment: "",
    startFirstSemester: "",
    endFirstSemester: "",
    startSecondSemester: "",
    endSecondSemester: "",
    startNormalExam: "",
    endNormalExam: "",
    startRecurrentExam: "",
    endRecurrentExam: "",
    forceUsePeriod: false,
    startNormalExamSecondSemester: "",
    endNormalExamSecondSemester: "",
    startRecurrentExamSecondSemester: "",
    endRecurrentExamSecondSemester: "",
    startSubscription: "",
    endSubscription: "",
    startSubscriptionSecondSemester: "",
    endSubscriptionSecondSemester: ""
};
export const academicPeriodSlice = createSlice({
    name: "academicPeriodForm",
    initialState,
    reducers: {
        setUpdateAcademicPeriodData: (
            state, action: PayloadAction<AcademicPeriodType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateAcademicPeriodData: (
            state,
        ) => {
            return initialState
        }
    }
});
export const { setUpdateAcademicPeriodData,resetUpdateAcademicPeriodData } = academicPeriodSlice.actions;
export default academicPeriodSlice.reducer;